const translations = {
  confirm_change: 'Confirm Change',
  confirm_change_description: 'Are you sure you want to apply this change?',
};

export default translations;
